import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as driverApis from "../../utilities/apis/driver"
import * as complaintApis from "../../utilities/apis/complaint"
import * as complaintCommentApis from "../../utilities/apis/complaintComment"
import * as dispatcherServices from "../../utilities/services/dispatcher"
import { getComplaintStatus } from "../../utilities/enumerations/constants"
import Layout from "../../components/Layout"
import moment from "moment"

const User = () => {
  const navigate = useNavigate()
  const { user, token } = useSelector(state => state.user)
  const statusRef = useRef(null)
  const driverRef = useRef(null)
  const messageRef = useRef(null)
  const [edit, setEdit] = useState(false)
  const [drivers, setDrivers] = useState([])
  const [complaint, setComplaint] = useState({})
  const [complaintComments, setComplaintComments] = useState([])
  const params = new URLSearchParams(window.location.search)

  const handleAssign = async (e) => {
    if (!driverRef.current.value) return alert('Select a Rider')

    try {
      const payload = []
      payload.push({
        complaint_id: params.get("id"),
        driver_id: parseInt(driverRef.current.value)
      })
      const response = await dispatcherServices.complaintAssigned(token, payload)
      if (!response.status) throw new Error(response.message)

      getComplaint()
    } catch (error) {
      alert(error.message)
    }
  }

  const handleResolve = async () => {
    try {
      const response = await complaintApis.resolveComplaint(token, { id: complaint.id })
      if (!response.status) throw new Error(response.message)

      getComplaint()
    } catch (error) {
      alert(error.message)
    }
  }

  const getDrivers = async () => {
    try {
      const response = await driverApis.getDrivers(token, {})
      if (!response.status) throw new Error(response.message)

      const activeDriver = response.drivers.filter(driver => driver.active === true)
      setDrivers(activeDriver)
    } catch (error) {
      alert(error.message)
    }
  }

  const getComplaint = async () => {
    try {
      const response = await complaintApis.getComplaint(token, params.get("id"))
      if (!response.status) throw new Error(response.message)

      setComplaint(response.complaint)
      driverRef.current.value = response.complaint.driver_id || ""
    } catch (error) {
      alert(error.message)
    }
  }

  const getComplaintComments = async () => {
    try {
      const query = new URLSearchParams({ complaint_id: params.get("id") })
      const response = await complaintCommentApis.getComplaintComments(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setComplaintComments(response.complaint_comments)
    } catch (error) {
      alert(error.message)
    }
  }

  const handleStatusChange = async (e) => {
    try {
      const payload = {
        id: params.get("id"),
        complaint_id: complaint.id,
        status: e.target.value
      }
      const response = await complaintApis.updateComplaint(token, payload)
      if (!response.status) throw new Error(response.message)

      alert("Complaint status changed successfully")
      statusRef.current.value = ""
      setEdit(false)
      getComplaint()
    } catch (error) {
      alert("Error creating order: " + error.message)
    }
  }

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()
      const payload = {
        message: e.target.message.value,
        complaint_id: complaint.id
      }
      const response = await complaintCommentApis.createComplaintComment(token, payload)
      if (!response.status) throw new Error(response.message)

      alert("Complaint Comment submitted successfully")
      e.target.reset()
      getComplaintComments()
    } catch (error) {
      alert("Error creating order: " + error.message)
    }
  }

  useEffect(() => {
    if (!user) navigate("/")

    if (params.has("id")) {
      getDrivers()
      getComplaint()
      getComplaintComments()
    }
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="d-flex flex-column gap-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex gap-3 align-items-center">
                    <button type="button" className="btn btn-secondary rounded-4" onClick={() => navigate(-1)}><i className="bi bi-chevron-left"></i></button>
                    <p className="lead text-body-emphasis fw-bold m-0">Complaint #{complaint.id}</p>
                    {!edit && <p className="m-0" onDoubleClick={() => setEdit(true)}>{getComplaintStatus[complaint.status]}</p>}
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    {edit && <select ref={statusRef} className="form-select rounded-4" onChange={handleStatusChange}>
                      <option value="">Select Status</option>
                      <option value="pending">Pending</option>
                      <option value="assigned">Assigned</option>
                      <option value="resolved">Resolved</option>
                    </select>}
                    {edit && <button type="button" className="btn btn-light-danger rounded-4 flex-shrink-0" onClick={() => setEdit(false)}>Cancel</button>}
                    {!edit && complaint.status !== "resolved" && <button type="button" className="btn btn-theme rounded-4 flex-shrink-0" onClick={handleResolve}>Mark as Resolved</button>}
                  </div>
                </div>

                <div className="card rounded-4 shadow-none">
                  <div className="card-body py-4">
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Category</label>
                        <p className="text-capitalize m-0">{complaint.category}</p>
                      </div>
                      {/* <div className="col-md-6">
                        <label className="form-label">Status</label>
                        {!edit && <p onDoubleClick={() => setEdit(true)}>{getComplaintStatus[complaint.status]}</p>}
                        {edit && <select ref={statusRef} className="form-select form-select-sm rounded-3" onChange={handleStatusChange}>
                          <option value="">Select Status</option>
                          <option value="pending">Pending</option>
                          <option value="assigned">Assigned</option>
                          <option value="resolved">Resolved</option>
                        </select>}
                      </div> */}
                      {complaint.status === "resolved" && <div className="col-md-6">
                        <label className="form-label">Resolved By</label>
                        <p className="m-0">{complaint.user?.name}</p>
                      </div>}
                    </div>
                    <div>
                      <label className="form-label">Message</label>
                      <p className="m-0">{complaint.message}</p>
                    </div>
                  </div>
                </div>

                <div className="card rounded-4 shadow-none">
                  <div className="card-body py-4">
                    <form onSubmit={handleSubmit}>
                      <div className="d-flex gap-2">
                        <input type="text" name="message" className="form-control rounded-3 bg-light" placeholder="Leave a comment..." required></input>
                        <button type="submit" className="btn btn-theme rounded-3">Post</button>
                      </div>
                    </form>
                  </div>
                </div>
                <p className="text-body-tertiary text-end m-0">Only you and rider can see comments</p>
                {!!complaintComments.length && <p className="lead text-body-emphasis fw-bold m-0">Comments</p>}
                {complaintComments.map((comment) => {
                  return (
                    <div key={comment.id.toString()} className="card rounded-4 shadow-none">
                      <div className="card-body p-3">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="driver-icon flex-shrink-0 bg-body-secondary rounded-3">
                            <i className="bi bi-person text-body-secondary"></i>
                          </div>
                          <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-center">
                              {comment.user && <p className="fw-bold m-0">{comment.user.name}</p>}
                              {comment.driver && <p className="fw-bold m-0">{comment.driver.name}</p>}
                              <p className="small text-muted m-0 fst-italic">{moment(comment.created_at).fromNow()}</p>
                            </div>
                            <p className="small text-muted m-0">{comment.message}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex flex-column gap-3">
                <div className="card rounded-4 shadow-none">
                  <div className="card-body py-4">
                    <p className="lead text-body-emphasis fw-bold mb-3">Rider</p>
                    <div className="d-flex gap-2">
                      <select ref={driverRef} className="form-select form-select-sm rounded-3">
                        <option value="">Select Rider</option>
                        {drivers.map((driver) => <option key={driver.id.toString()} value={driver.id}>{driver.name}</option>)}
                      </select>
                      <button type="button" className="btn btn-sm btn-theme rounded-3" onClick={handleAssign}>Assign</button>
                    </div>
                  </div>
                </div>

                <div className="card rounded-4 shadow-none">
                  <div className="card-body py-4">
                    <p className="lead text-body-emphasis fw-bold mb-3">Customer</p>
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <p className="m-0">{complaint.name || "N/A"}</p>
                    </div>
                    <div>
                      <label className="form-label">Mobile</label>
                      <p className="m-0">{complaint.customer?.mobile}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default User
